<template>
  <div class="auth-rule">
    <div class="auth-head">{{ title }}</div>
    <div class="auth-body">
      <el-form :model="editForm" :label-position="position" :rules="editRule">
        <el-form-item label="投票规则" prop="rules">
          <el-select v-model="editForm.rules" placeholder="请选择" clearable disabled>
            <el-option v-for="item in rules" :key="item.ID" :label="item.label" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参与组织" prop="orgID">
          <el-checkbox-group v-model="editForm.orgID" disabled>
            <el-checkbox v-for="ele in orgList" :key="ele.OrgId" :label="ele.OrgId">{{
              ele.OrgName
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="参与角色" prop="roleID">
          <el-checkbox-group v-model="editForm.roleID" disabled>
            <el-checkbox v-for="ele in roleLabel" :key="ele.value" :label="ele.value">{{
              ele.label
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthRule',
  props: {
    title: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => {
        return []
      }
    },
    resultList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    roleLabel: {
      type: Array,
      default: () => {
        return []
      }
    },
    type: {
      type: Number,
      default: () => {
        return 5
      }
    }
  },
  data() {
    return {
      position: 'left',
      editForm: {
        orgID: [],
        roleID: [],
        rules: 0
      },
      editRule: {
        orgID: [{ required: true, message: '请选择组织', trigger: 'blur' }],
        roleID: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        rules: [{ required: true, message: '请选择投票规则', trigger: 'blur' }]
      }
    }
  },
  computed: {
    orgList: {
      get() {
        return this.resultList['Orgs']
      },
      set(val) {}
    }
  },
  watch: {
    resultList(val) {
      if (val) {
        this.handleSelect(val)
      }
    }
  },
  methods: {
    handleSelect(obj) {
      //处理组织和角色选中
      let newArr = obj.Orgs
      let newOrg = newArr.map(ele => {
        if (ele.Status === 1) return ele.OrgId
      })
      this.editForm.orgID = newOrg
      let roleArr = obj.Roles
      roleArr.map(item => {
        if (item.Selected === 1) {
          this.editForm.roleID = item.Role === 0 ? [0] : [1]
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'auth-rule',
  (
    --auth-rule-head-background-color: #4B5471,
    --auth-rule-head-color: #A3AFB5,
    --auth-rule-border-color: #4B5471
  ),
  (
    --auth-rule-head-background-color: #ebebeb,
    --auth-rule-head-color: #192227,
    --auth-rule-border-color: #ebebeb
  )
);
.auth-rule {
  @include adaptation(
    (
      --auth-rule-min-height: 200px,
      --auth-rule-border-width: 1px,
      --auth-rule-border-radius: 4px,
      --auth-rule-head-height: 40px,
      --auth-rule-head-border-bottom-width: 1px,
      --auth-rule-head-font-size: 14px,
      --auth-rule-head-padding: 0 20px,
      --auth-rule-body-padding: 20px 20px 0
    )
  );

  min-height: var(--auth-rule-min-height);
  border: var(--auth-rule-border-width) solid var(--auth-rule-border-color);
  border-radius: var(--auth-rule-border-radius);
  .auth-head {
    height: var(--auth-rule-head-height);
    background: var(--auth-rule-head-background-color);
    border-bottom: var(--auth-rule-head-border-bottom-width) solid var(--auth-rule-border-color);
    font-size: var(--auth-rule-head-font-size);
    line-height: var(--auth-rule-head-height);
    color: var(--auth-rule-head-color);
    padding: var(--auth-rule-head-padding);
  }
  .auth-body {
    padding: var(--auth-rule-body-padding);
  }
}
</style>
